// UK mobile numbers start 07 (or +447/00447) — the only numbers that can receive WhatsApp.
export function isUkMobile(phone) {
  if (!phone) return false;
  let digits = phone.replace(/\D/g, "");
  if (digits.startsWith("44")) digits = "0" + digits.slice(2);
  return digits.startsWith("07");
}
